import { render, staticRenderFns } from "./questionBank.vue?vue&type=template&id=680b37d4&scoped=true&"
import script from "./questionBank.vue?vue&type=script&lang=js&"
export * from "./questionBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680b37d4",
  null
  
)

export default component.exports